export type Route =
  | 'accueil'
  | 'parcours'
  | 'vocabulaire'
  | 'grammaire'
  | 'prononciation'
  | 'ecoute'
  | 'tache'
  | 'acquis'
  | 'parametres';

const validRoutes: ReadonlySet<Route> = new Set([
  'accueil', 'parcours', 'vocabulaire', 'grammaire',
  'prononciation', 'ecoute', 'tache', 'acquis', 'parametres',
]);

export function currentRoute(): Route {
  const hash = window.location.hash.replace(/^#\/?/, '');
  return validRoutes.has(hash as Route) ? (hash as Route) : 'accueil';
}

export function navigate(route: Route): void {
  window.location.hash = `/${route}`;
}

export function onRouteChange(cb: (route: Route) => void): void {
  window.addEventListener('hashchange', () => cb(currentRoute()));
}
